import React, {useEffect, useState} from 'react'
import {LoadingData} from '../../../../components/LoadingData'
import {Link} from 'react-router-dom'
import {Tooltip} from 'react-tooltip'
import {getTopReferencePiece} from '../../../../components/requests'
import {useLocation} from 'react-router'

interface LocationState {
  filters?: any
}

const DemandPieceRechercher = () => {
  const location = useLocation()
  const state = location.state as LocationState | null
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<any>([])

  useEffect(() => {
    getTopReferencePieceData()
  }, [])

  const getTopReferencePieceData = () => {
    setLoading(true)
    getTopReferencePiece()
      .then((response) => {
        if (response?.status === 200) {
          if (response?.data !== undefined) {
            setData(response?.data)
            setLoading(false)
          }
        }
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  return (
    <>
      {/* begin::Row  */}
      <div className='row g-5 g-xl-8'>
        {/* begin::Col  */}
        <div className='col-xxl-12'>
          <div className={`card card-xxl-stretch mb-5 mb-xl-8`}>
            {/* begin::Header */}
            <div className='card-header border-0 pt-5' style={{display: 'block'}}>
              <Link
                to={`/demandes/liste`}
                state={{filters: state?.filters}}
                data-tooltip-id='tooltip'
                data-tooltip-content='Revenir en arrière'
                data-tooltip-place='right'
              >
                <img src='/media/svg/custom/prev-arrow.svg' width={40} />
              </Link>
              <h3 className='card-title align-items-start flex-column mt-5'>
                <span className='card-label fw-bold fs-3 mb-1'>Pièces les plus recherchées</span>
              </h3>
            </div>
            {/* end::Header */}
            {loading ? (
              <LoadingData />
            ) : (
              <>
                <div className='card-body py-3'>
                  {/* begin::Table container */}
                  <div className='table-responsive'>
                    {/* begin::Table */}
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      {/* begin::Table head */}
                      <thead>
                        <tr className='fw-bold text-muted'>
                          <th className='min-w-150px'>Rang</th>
                          <th className='min-w-140px'>Numéro</th>
                          <th className='min-w-150px'>Pièce</th>
                          <th className='min-w-150px'>Nombre de demandes</th>
                          <th className='min-w-150px'>Disponibilité %</th>
                        </tr>
                      </thead>
                      {/* end::Table head */}
                      {/* begin::Table body */}
                      <tbody>
                        {data.length &&
                          data.map((piece, index) => {
                            return (
                              <tr key={piece?.typePiece?.id}>
                                <td style={{width: 100}}>
                                  <p className='text-dark fw-bold text-hover-primary fs-6 mb-0'>
                                    {index + 1}
                                  </p>
                                </td>
                                <td>
                                  <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                    {piece?.typePiece?.sousCategorie.categorie.code}
                                    {piece?.typePiece?.sousCategorie.code}
                                    {piece?.typePiece?.code}
                                  </p>
                                </td>
                                <td>
                                  <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                    {piece?.typePiece?.nom.toUpperCase()}
                                  </p>
                                </td>
                                <td>
                                  <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                    {piece?.total}
                                  </p>
                                </td>
                                <td>
                                  <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                    -
                                  </p>
                                </td>
                              </tr>
                            )
                          })}
                      </tbody>
                      {/* end::Table body */}
                    </table>
                    {/* end::Table */}
                    <Tooltip id='tooltip' />
                  </div>
                  {/* end::Table container */}
                </div>
              </>
            )}
          </div>
        </div>
        {/* end::Col  */}
      </div>
      {/* end::Row  */}
    </>
  )
}

export {DemandPieceRechercher}
